var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FF2642",
  clipPath: "url(#exit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.75 12.917a.916.916 0 0 0-.917.916V17.5c0 .505-.41.917-.917.917h-2.75V4.667c0-.783-.498-1.483-1.248-1.743l-.271-.09h4.27c.505 0 .916.41.916.916V6.5a.916.916 0 1 0 1.833 0V3.75A2.753 2.753 0 0 0 12.917 1H3.063c-.034 0-.064.016-.098.02-.044-.004-.086-.02-.13-.02A1.835 1.835 0 0 0 1 2.833v16.5c0 .783.499 1.483 1.248 1.743l5.517 1.839c.187.058.373.085.568.085a1.835 1.835 0 0 0 1.834-1.833v-.917h2.75a2.753 2.753 0 0 0 2.75-2.75v-3.667a.916.916 0 0 0-.917-.916"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.731 9.519-3.666-3.667A.917.917 0 0 0 17.5 6.5v2.75h-3.667a.917.917 0 0 0 0 1.833H17.5v2.75a.918.918 0 0 0 1.565.648l3.666-3.666a.916.916 0 0 0 0-1.296"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "exit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgExit;